// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Roboto", sans-serif !important;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
  overflow-x: hidden;
}

a {
  text-decoration: none;
}

/* login registraction css */

.login-form {
  margin-top: 10rem !important;
  background-color: #f8f8f8 !important;
}

.register-form {
  margin-top: 5rem !important;
}

/* Menu icon css */

.css-cveggr-MuiListItemIcon-root {
  min-width: 37px !important;
}

.dataCard {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 40%;
  border-radius: 0.5em;
  padding: 1em;
}

.revenueCard {
  width: 100%;
  height: 20rem;
}

.customerCard {
  width: 100%;
  height: 20rem;
}

.categoryCard {
  width: 100%;
  height: 20rem;
}

/* Menu css add Karthick open*/
#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root,
#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root svg {
  color: #fff !important;
}
#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root.Mui-selected,
#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root:hover {
  background: #fff;
  color: #1959bb !important;
  border-radius: 35px;
  /* margin: 0px 8px !important; */
}

#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root.Mui-selected svg,
#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root:hover svg {
  color: #1959bb !important;
}

.css-1nxmd3h-MuiListItem-root {
  width: 90% !important;
  margin: 0 auto;
  font-size: 20px !important;
}
.css-10hburv-MuiTypography-root {
  font-size: 16px !important;
  font-weight: bold !important;
}

#sidebar_drawer ul li.MuiListItem-root {
  margin-bottom: 6px;
  padding: 0% 4% !important;
}

.sidebar-text {
  font-weight: bold !important;
}

.css-yb0lig {
  font-weight: bold !important;
  font-size: 15px !important;
}

.css-1f8bwsm {
  min-width: 30px !important;
}
/* Menu css add Karthick closed*/
body {
  background: #f1f2f6 !important;
}
.title_txt,
.a_time {
  color: #1959bb;
}
.gray {
  background: #e8e8e8;
  border: 1px solid #888;
  box-shadow: 1px 0px 3px #ddd;
  border-radius: 10px;
}
.a_time {
  font-size: 32px;
  font-weight: bold;
}
.closebtn {
  color: #1959bb;
  font-size: 20px;
  cursor: pointer;
}
.modal-header .btn-close {
  background-color: blue !important;
  color: white !important;
}

.custom-close-button {
  background-color: #1959bb;
  color: white;
  border: none;
  font-size: 16px;
  padding: 5px 11px;
  border-radius: 10px;
  cursor: pointer;
}

.form-check-input {
  border-color: #888 !important;
}

/*Login css bala */
.login-web-view .custom-login-form {
  max-width: 80%;
  margin: 0 auto;
}
.login-web-view {
  height: 100vh;
}
.login-row {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.MuiButtonBase-root {
  text-transform: capitalize;
}
.login-web-view .login-forgot {
  color: #1959bc !important;
  opacity: 0.6;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  margin-top: 20px !important;
  margin-bottom: 16px !important;
  text-transform: none !important;
}

.btncheckout {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.checkout-checkbox {
  font-size: 15px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 7rem !important;
}

.content-card {
  width: 96%;
  height: 31.25 !important;
  margin: 1%;
  background-color: #f8f8f8 !important;
  border: 1px solid #f8f8f8;
  margin-left: 20px;
}

.history-card-card {
  width: 96%;
  margin: 1%;
  background-color: #f8f8f8 !important;
  border: 1px solid #f8f8f8;
  margin-left: 20px;
  border-radius: 10px 10px 0px 0px !important;
}
.history-card {
  width: 96%;
  margin: 1%;
  background-color: #f8f8f8 !important;
  border: 1px solid #f8f8f8;
  margin-left: 20px;
}

.head-history-card {
  background-color: #1959bc !important;
  color: white !important;
  border-radius: 8px 8px 0px 0px !important;
}

.showtime-section {
  font-size: 14px;
  margin-left: 5px;
}

/* Profile section css */
.add_photo {
  margin-left: 12px;
  font-size: 15px;
  border: 1px solid #b0b0b0 !important;
  color: #b0b0b0;
  background-color: white;
  text-transform: capitalize;
  border-radius: 5px;
}

.custom-form-label {
  color: #b0b0b0 !important;
  font-weight: 500 !important;
}

.update-btn {
  background-color: #4666ae !important;
  border-color: #4666ae !important;
  border-radius: 4px !important;
  font-size: 0.875rem;
}

.login-forgot {
  color: #1959bc !important;
}

#root *.coddgp_mobile_view {
  font-size: 10px !important;
}

.form-label {
  color: #000000 !important;
}

.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  height: 1em !important;
}

.img-fluid {
  border-radius: 30px 0px 0px 30px !important;
}

.login-div-web {
  border-radius: 30px !important;
}

.first-text-web {
  margin-top: 4rem !important;
}

.button-container {
  display: flex !important;
  justify-content: flex-end !important;
}

.form-reason-modal {
  padding-left: 5rem;
}

@media only screen and (max-width: 480px) {
  .custom-roster-row,
  .custom-profile-row,
  .custom-attendance-row {
    --bs-gutter-x: 0.5rem !important;
    --bs-gutter-x: 0.5rem !important;
  }
  .main-card {
    margin-bottom: 10px !important;
  }

  .content-card {
    margin-top: 1rem;
    width: 95%;
    margin-left: 8px;
  }
  .profile-card {
    width: 105%;
    margin-left: -10px;
  }
  .form-div {
    margin-top: 5px !important;
    width: 19rem !important;
  }
  .checkout-checkbox {
    padding-left: 3rem !important;
    font-size: 15px;
  }

  .history-card {
    width: 95%;
    margin-left: 8px;
  }

  .history-card-card {
    width: 95%;
    margin-left: 8px;
    border-radius: 10px 10px 0px 0px !important;
  }

  .showtime-section {
    width: 60px !important;
    font-size: 10px !important;

    text-align: center;
  }
  .showtime-section2 {
    font-size: 11px !important;

    text-align: center;
  }

  .custom-col {
    /* font-size: 11px !important; */
    font-size: 13px !important;
    padding-left: 1% !important;
    padding-right: 1% !important;
  }

  .image-container {
    position: relative;
    width: 100% !important;
    height: 60% !important;
    border-radius: 0px 0px 0px 0px !important;
  }

  .img-fluid {
    border-radius: 0px 0px 45px 45px !important;
    width: 100% !important;
  }

  .login-div-web {
    border-radius: 0px 0px 0px 0px !important;
  }

  .first-text-web {
    color: #525252;
    font-size: 24px !important;
    font-weight: 700 !important;
    margin-top: 1.1rem !important;
  }

  .login-login-btn {
    background-color: #1959bc !important;
    text-transform: capitalize !important;
    font-weight: 18px !important;
    font-weight: 700 !important;
  }
  .login-forgot {
    color: #1959bc !important;
    text-decoration: none !important;
    position: absolute;
    right: 0;
  }
  .button-container {
    display: flex;
    justify-content: flex-end;
  }
  .info_login {
    font-size: 14px !important;
    margin-bottom: 20rem !important;
  }
  .login-web-view {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
  }

  .table-row td {
    font-size: 15px !important;
  }

  .two-factor-verify {
    margin-bottom: 15rem !important;
  }

  .login-web-view .login-forgot {
    margin-top: 20px !important;
  }

  .card {
    --bs-card-spacer-x: 0rem !important;
  }
  .css-yfo96e {
    padding: 18px !important;
  }
  /*profile page css */
  .user_photodiv {
    margin-left: 20px !important;
    text-align: center;
    margin-top: 20px;
  }
  .user_right {
    margin-left: 20px !important;
    text-align: center;
  }
  .changephoto {
    border-color: #b0b0b0 !important;
    color: #b0b0b0 !important;
    padding: 0px 20px !important;
  }

  .profile-img {
    margin-left: 10px !important;
  }
  .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 15px 13px !important;
  }
  .css-u4tvz2-MuiFormLabel-root {
    color: #000000 !important;
    font-size: 14.5px !important;
  }
  .save-button2 {
    background-color: #4666ae !important;
    color: white !important;
    text-transform: capitalize !important;
  }
  .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 13px !important;
  }
  .css-1o9s3wi-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 13px 9px !important;
  }
  .login-row {
    align-items: normal !important;
  }
  .form-reason-modal {
    padding-left: 2rem;
  }
}
.css-1k455el {
  justify-content: center !important;
}
@media only screen and (max-width: 500px) {
  #main_div.menu_open {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,4BAA4B;;AAE5B;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;;AAElB;EACE,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA,8BAA8B;AAC9B;;EAEE,sBAAsB;AACxB;AACA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;AACA,gCAAgC;AAChC;EACE,8BAA8B;AAChC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,UAAU;EACV,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,UAAU;EACV,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;;IAGE,gCAAgC;IAChC,gCAAgC;EAClC;EACA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;;IAE1B,kBAAkB;EACpB;EACA;IACE,0BAA0B;;IAE1B,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;IACE,2CAA2C;IAC3C,sBAAsB;EACxB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,cAAc;IACd,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;IACpC,qCAAqC;IACrC,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mCAAmC;EACrC;EACA;IACE,wBAAwB;EAC1B;EACA,oBAAoB;EACpB;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;EACA;IACE,gCAAgC;IAChC,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,oCAAoC;IACpC,uBAAuB;IACvB,qCAAqC;EACvC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,kCAAkC;AACpC;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap\");\n\n* {\n  font-family: \"Roboto\", sans-serif !important;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Roboto\", sans-serif;\n  overflow-x: hidden;\n}\n\na {\n  text-decoration: none;\n}\n\n/* login registraction css */\n\n.login-form {\n  margin-top: 10rem !important;\n  background-color: #f8f8f8 !important;\n}\n\n.register-form {\n  margin-top: 5rem !important;\n}\n\n/* Menu icon css */\n\n.css-cveggr-MuiListItemIcon-root {\n  min-width: 37px !important;\n}\n\n.dataCard {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  width: 40%;\n  border-radius: 0.5em;\n  padding: 1em;\n}\n\n.revenueCard {\n  width: 100%;\n  height: 20rem;\n}\n\n.customerCard {\n  width: 100%;\n  height: 20rem;\n}\n\n.categoryCard {\n  width: 100%;\n  height: 20rem;\n}\n\n/* Menu css add Karthick open*/\n#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root,\n#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root svg {\n  color: #fff !important;\n}\n#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root.Mui-selected,\n#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root:hover {\n  background: #fff;\n  color: #1959bb !important;\n  border-radius: 35px;\n  /* margin: 0px 8px !important; */\n}\n\n#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root.Mui-selected svg,\n#sidebar_drawer ul li.MuiListItem-root .MuiButtonBase-root:hover svg {\n  color: #1959bb !important;\n}\n\n.css-1nxmd3h-MuiListItem-root {\n  width: 90% !important;\n  margin: 0 auto;\n  font-size: 20px !important;\n}\n.css-10hburv-MuiTypography-root {\n  font-size: 16px !important;\n  font-weight: bold !important;\n}\n\n#sidebar_drawer ul li.MuiListItem-root {\n  margin-bottom: 6px;\n  padding: 0% 4% !important;\n}\n\n.sidebar-text {\n  font-weight: bold !important;\n}\n\n.css-yb0lig {\n  font-weight: bold !important;\n  font-size: 15px !important;\n}\n\n.css-1f8bwsm {\n  min-width: 30px !important;\n}\n/* Menu css add Karthick closed*/\nbody {\n  background: #f1f2f6 !important;\n}\n.title_txt,\n.a_time {\n  color: #1959bb;\n}\n.gray {\n  background: #e8e8e8;\n  border: 1px solid #888;\n  box-shadow: 1px 0px 3px #ddd;\n  border-radius: 10px;\n}\n.a_time {\n  font-size: 32px;\n  font-weight: bold;\n}\n.closebtn {\n  color: #1959bb;\n  font-size: 20px;\n  cursor: pointer;\n}\n.modal-header .btn-close {\n  background-color: blue !important;\n  color: white !important;\n}\n\n.custom-close-button {\n  background-color: #1959bb;\n  color: white;\n  border: none;\n  font-size: 16px;\n  padding: 5px 11px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.form-check-input {\n  border-color: #888 !important;\n}\n\n/*Login css bala */\n.login-web-view .custom-login-form {\n  max-width: 80%;\n  margin: 0 auto;\n}\n.login-web-view {\n  height: 100vh;\n}\n.login-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.MuiButtonBase-root {\n  text-transform: capitalize;\n}\n.login-web-view .login-forgot {\n  color: #1959bc !important;\n  opacity: 0.6;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-decoration-line: underline;\n  margin-top: 20px !important;\n  margin-bottom: 16px !important;\n  text-transform: none !important;\n}\n\n.btncheckout {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.checkout-checkbox {\n  font-size: 15px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 7rem !important;\n}\n\n.content-card {\n  width: 96%;\n  height: 31.25 !important;\n  margin: 1%;\n  background-color: #f8f8f8 !important;\n  border: 1px solid #f8f8f8;\n  margin-left: 20px;\n}\n\n.history-card-card {\n  width: 96%;\n  margin: 1%;\n  background-color: #f8f8f8 !important;\n  border: 1px solid #f8f8f8;\n  margin-left: 20px;\n  border-radius: 10px 10px 0px 0px !important;\n}\n.history-card {\n  width: 96%;\n  margin: 1%;\n  background-color: #f8f8f8 !important;\n  border: 1px solid #f8f8f8;\n  margin-left: 20px;\n}\n\n.head-history-card {\n  background-color: #1959bc !important;\n  color: white !important;\n  border-radius: 8px 8px 0px 0px !important;\n}\n\n.showtime-section {\n  font-size: 14px;\n  margin-left: 5px;\n}\n\n/* Profile section css */\n.add_photo {\n  margin-left: 12px;\n  font-size: 15px;\n  border: 1px solid #b0b0b0 !important;\n  color: #b0b0b0;\n  background-color: white;\n  text-transform: capitalize;\n  border-radius: 5px;\n}\n\n.custom-form-label {\n  color: #b0b0b0 !important;\n  font-weight: 500 !important;\n}\n\n.update-btn {\n  background-color: #4666ae !important;\n  border-color: #4666ae !important;\n  border-radius: 4px !important;\n  font-size: 0.875rem;\n}\n\n.login-forgot {\n  color: #1959bc !important;\n}\n\n#root *.coddgp_mobile_view {\n  font-size: 10px !important;\n}\n\n.form-label {\n  color: #000000 !important;\n}\n\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\n  height: 1em !important;\n}\n\n.img-fluid {\n  border-radius: 30px 0px 0px 30px !important;\n}\n\n.login-div-web {\n  border-radius: 30px !important;\n}\n\n.first-text-web {\n  margin-top: 4rem !important;\n}\n\n.button-container {\n  display: flex !important;\n  justify-content: flex-end !important;\n}\n\n.form-reason-modal {\n  padding-left: 5rem;\n}\n\n@media only screen and (max-width: 480px) {\n  .custom-roster-row,\n  .custom-profile-row,\n  .custom-attendance-row {\n    --bs-gutter-x: 0.5rem !important;\n    --bs-gutter-x: 0.5rem !important;\n  }\n  .main-card {\n    margin-bottom: 10px !important;\n  }\n\n  .content-card {\n    margin-top: 1rem;\n    width: 95%;\n    margin-left: 8px;\n  }\n  .profile-card {\n    width: 105%;\n    margin-left: -10px;\n  }\n  .form-div {\n    margin-top: 5px !important;\n    width: 19rem !important;\n  }\n  .checkout-checkbox {\n    padding-left: 3rem !important;\n    font-size: 15px;\n  }\n\n  .history-card {\n    width: 95%;\n    margin-left: 8px;\n  }\n\n  .history-card-card {\n    width: 95%;\n    margin-left: 8px;\n    border-radius: 10px 10px 0px 0px !important;\n  }\n\n  .showtime-section {\n    width: 60px !important;\n    font-size: 10px !important;\n\n    text-align: center;\n  }\n  .showtime-section2 {\n    font-size: 11px !important;\n\n    text-align: center;\n  }\n\n  .custom-col {\n    /* font-size: 11px !important; */\n    font-size: 13px !important;\n    padding-left: 1% !important;\n    padding-right: 1% !important;\n  }\n\n  .image-container {\n    position: relative;\n    width: 100% !important;\n    height: 60% !important;\n    border-radius: 0px 0px 0px 0px !important;\n  }\n\n  .img-fluid {\n    border-radius: 0px 0px 45px 45px !important;\n    width: 100% !important;\n  }\n\n  .login-div-web {\n    border-radius: 0px 0px 0px 0px !important;\n  }\n\n  .first-text-web {\n    color: #525252;\n    font-size: 24px !important;\n    font-weight: 700 !important;\n    margin-top: 1.1rem !important;\n  }\n\n  .login-login-btn {\n    background-color: #1959bc !important;\n    text-transform: capitalize !important;\n    font-weight: 18px !important;\n    font-weight: 700 !important;\n  }\n  .login-forgot {\n    color: #1959bc !important;\n    text-decoration: none !important;\n    position: absolute;\n    right: 0;\n  }\n  .button-container {\n    display: flex;\n    justify-content: flex-end;\n  }\n  .info_login {\n    font-size: 14px !important;\n    margin-bottom: 20rem !important;\n  }\n  .login-web-view {\n    overflow-x: hidden !important;\n    overflow-y: hidden !important;\n  }\n\n  .table-row td {\n    font-size: 15px !important;\n  }\n\n  .two-factor-verify {\n    margin-bottom: 15rem !important;\n  }\n\n  .login-web-view .login-forgot {\n    margin-top: 20px !important;\n  }\n\n  .card {\n    --bs-card-spacer-x: 0rem !important;\n  }\n  .css-yfo96e {\n    padding: 18px !important;\n  }\n  /*profile page css */\n  .user_photodiv {\n    margin-left: 20px !important;\n    text-align: center;\n    margin-top: 20px;\n  }\n  .user_right {\n    margin-left: 20px !important;\n    text-align: center;\n  }\n  .changephoto {\n    border-color: #b0b0b0 !important;\n    color: #b0b0b0 !important;\n    padding: 0px 20px !important;\n  }\n\n  .profile-img {\n    margin-left: 10px !important;\n  }\n  .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\n    padding: 15px 13px !important;\n  }\n  .css-u4tvz2-MuiFormLabel-root {\n    color: #000000 !important;\n    font-size: 14.5px !important;\n  }\n  .save-button2 {\n    background-color: #4666ae !important;\n    color: white !important;\n    text-transform: capitalize !important;\n  }\n  .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n    padding: 13px !important;\n  }\n  .css-1o9s3wi-MuiInputBase-input-MuiOutlinedInput-input {\n    padding: 13px 9px !important;\n  }\n  .login-row {\n    align-items: normal !important;\n  }\n  .form-reason-modal {\n    padding-left: 2rem;\n  }\n}\n.css-1k455el {\n  justify-content: center !important;\n}\n@media only screen and (max-width: 500px) {\n  #main_div.menu_open {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
